/*@flow*/
import type { Node } from 'react';
import React from 'react';
import * as loaders from 'queries/loaders';
import getAssetCompanyId from 'lib/getAssetCompanyId';
import { useApolloClient } from '@apollo/react-hooks';
import Item from './Item';
import AsyncSelect from './AsyncSelect';

type PropsT = {
  filterName: string,
  label: React$Node,
  value: any,
  onChange: (any) => any,
  hideWhen?: () => boolean,
};

export default function StatusesTemplate(locals: PropsT): null | Node {
  const client = useApolloClient();
  const filterName = locals.filterName;
  const companyId = getAssetCompanyId();
  const o = { client, companyId, filterName };
  const loadValues = () => loaders.projectStatusesLoader(o);
  if (locals.hideWhen && locals.hideWhen()) return null;

  return (
    <Item label={locals.label}>
      <AsyncSelect
        className="status-select-field"
        loadValues={loadValues}
        value={locals.value}
        placeholder="Select status"
        onChange={locals.onChange}
      />
    </Item>
  );
}
